import { GalleryDto, GalleryTheme } from '@nusign/picflow-backend-types';
import {
  assetSectionLayouts,
  assetSectionSizes,
  assetSectionSpacings,
  sectionVerticalPadding,
  sectionWidths,
} from '../../lib/default-asset-section';
import { isDarkColorFromString } from '../../lib/is-dark-color';

export const defaultTheme: GalleryTheme = {
  asset_page: { ambient_mode: false, background_color: 'black' },
  cover: {
    overlay_color: 'rgba(0, 0, 0, 0.5)',
    title_typography: {
      text_alignment: 'center',
      font_color: null,
      font_size: 2,
      font_family: null,
      text_transform: null,
      font_weight: 'bold',
      font_style: null,
      letter_spacing: null,
    },
    paragraph_typography: {
      text_alignment: 'center',
      font_color: null,
      font_size: 2,
      font_family: null,
      text_transform: null,
      font_weight: 'regular',
      font_style: null,
      letter_spacing: null,
    },
    design: 'simple',
    size: 'medium',
    content_position: [0.5, 0.5],
  },
  layout_page: { background_color: 'rgba(255, 255, 255, 1)' },
  section: {
    title_typography: {
      text_alignment: 'center',
      font_color: null,
      font_size: 2,
      font_family: null,
      text_transform: null,
      font_weight: 'bold',
      font_style: null,
      letter_spacing: null,
    },
    paragraph_typography: {
      text_alignment: 'center',
      font_color: null,
      font_size: 2,
      font_family: null,
      text_transform: null,
      font_weight: 'regular',
      font_style: null,
      letter_spacing: null,
    },
    background_color: null,
    vertical_padding: sectionVerticalPadding.medium,
    show_filenames: false,
    grid_layout: assetSectionLayouts[0],
    width: sectionWidths.medium,
    display_size: assetSectionSizes.medium,
    spacing: assetSectionSpacings.medium,
    rounded_corners: false,
  },
};

export const calcLegacyTheme = (gallery: GalleryDto, hasPreviewAsset = false): GalleryTheme => {
  const size = gallery.cover.size as 'medium' | 'small' | 'large';

  return {
    cover: {
      ...defaultTheme.cover,
      overlay_color: gallery.cover.overlay_color || defaultTheme.cover.overlay_color,
      title_typography: {
        ...defaultTheme.cover.title_typography,
        ...{ font_color: gallery.cover.uuid || hasPreviewAsset ? '#ffffff' : '#1f232e' },
        ...gallery.cover.title_typography,
      },
      paragraph_typography: {
        ...defaultTheme.cover.paragraph_typography,
        ...{ font_color: gallery.cover.uuid || hasPreviewAsset ? '#ffffff' : '#1f232e' },
        ...gallery.cover.paragraph_typography,
      },
      design: gallery.cover.uuid || hasPreviewAsset ? 'simple' : null,
      size: size || defaultTheme.cover.size,
      content_position: gallery.cover.content_position || defaultTheme.cover.content_position,
    },
    layout_page: { background_color: gallery.layout_background_color || defaultTheme.layout_page.background_color },
    asset_page: {
      ambient_mode: gallery.asset_ambient_mode,
      background_color: gallery.asset_background_color || 'black',
    },
    section: {
      ...defaultTheme.section,
      title_typography: {
        ...defaultTheme.section.title_typography,
        font_color: isDarkColorFromString(gallery.layout_background_color) ? '#ffffff' : '#1f232e',
      },
      paragraph_typography: {
        ...defaultTheme.section.paragraph_typography,
        font_color: isDarkColorFromString(gallery.layout_background_color) ? '#ffffff' : '#1f232e',
      },
    },
  };
};
